// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".childOutbound-wrap {\n  padding-bottom: 40px;\n}\n.childOutbound-wrap .child-outbound-description {\n  padding-top: 10px;\n  margin: 0 20px;\n}\n.childOutbound-wrap .child-outbound-description .child-outbound-input {\n  margin-left: 10px;\n}\n.childOutbound-wrap .dialog-footer {\n  float: right;\n  margin-top: 13px;\n}", ""]);
// Exports
module.exports = exports;
